import { ChevronRight } from 'lucide-react';
import Image from 'next/image';
import { paths } from 'src/config/paths';

import { Button, Text } from '@/design-system/components/ui';

import { RouterLink } from './RouterLink';
import Seo from './Seo';

export default function InternalServerErrorPage() {
  return (
    <>
      <Seo title="Error: Server Error" />
      <main className="tw:flex tw:items-center tw:grow tw:py-20">
        <div className="tw:container tw:max-w-screen-lg tw:mx-auto tw:px-6">
          <div className="tw:flex tw:justify-center tw:mb-12">
            <div className="tw:relative tw:w-[180px] tw:h-auto tw:max-w-full" style={{ aspectRatio: '1' }}>
              <Image
                alt="Internal server error"
                src="/assets/png/error-500.png"
                fill
                style={{ objectFit: 'contain' }}
              />
            </div>
          </div>
          <Text variant="title-sm" as="h1" className="tw:text-center">
            We&apos;ll Be Right Back!
          </Text>
          <Text variant="body-lg" color="muted" className="tw:text-center tw:mt-1">
            We apologize for any inconvenience this may cause, but we are working to improve your experience with our
            site. We expect to be back online shortly.
          </Text>
          <div className="tw:flex tw:justify-center tw:mt-12">
            <Button variant="primary" asChild>
              <RouterLink href={paths.index}>
                Take Me Home
                <ChevronRight size={16} />
              </RouterLink>
            </Button>
          </div>
        </div>
      </main>
    </>
  );
}
